import React from 'react';
import PropTypes from 'prop-types';

const EditIcon = (props) => {
  const {
    width, height, fill, className,
  } = props;

  const w = (width) ? width.toString().concat('px') : '20px';
  const h = (height) ? height.toString().concat('px') : '21px';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      className={(className) ? `icon ${className}` : 'icon'}
      viewBox="0 0 20 21"
      width={w}
      height={h}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
                // eslint-disable-next-line max-len
        d="M1 2.75332C1 2.3788 1.28631 2.0752 1.63949 2.0752H12.7454C13.0986 2.0752 13.3849 2.3788 13.3849 2.75332C13.3849 3.12784 13.0986 3.43145 12.7454 3.43145H2.27897V17.7189H14.721V9.25277C14.721 8.87825 15.0073 8.57464 15.3605 8.57464C15.7137 8.57464 16 8.87825 16 9.25277V18.3971C16 18.7716 15.7137 19.0752 15.3605 19.0752H1.63949C1.28631 19.0752 1 18.7716 1 18.3971V2.75332Z"
        fill={(fill) || '#FF5F14'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
                // eslint-disable-next-line max-len
        d="M16.4822 4.18714L15.9319 3.62543L10.3388 9.21852L10.0555 10.0585L10.8889 9.78041L16.4822 4.18714ZM11.4349 10.5319L9.01851 11.3381C8.88952 11.3811 8.73542 11.2239 8.77925 11.094L9.60045 8.65931L16.6427 1.61708C17.5889 1.19298 18.8388 2.37958 18.5098 3.38964L18.4772 3.48967L11.4349 10.5319ZM17.7335 2.93583L16.992 3.6773L16.4417 3.11559L17.1903 2.36703C17.4744 2.31742 17.7966 2.64097 17.7335 2.93583Z"
        fill={(fill) || '#FF5F14'}
      />
    </svg>
  );
};

EditIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
  className: PropTypes.string,
};

export default EditIcon;
